export default __webpack_public_path__ + "static/media/Group3235.c4c4af5a.png";